var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-inline" },
    [
      _vm.isLink
        ? [
            _c(
              "a",
              {
                staticClass: "custom-link-nohighlight",
                attrs: { href: _vm.linkUrl, target: "_blank", rel: "noopener" },
              },
              [
                _vm.$slots["accession"]
                  ? _vm._t("accession")
                  : [_vm._v(_vm._s(_vm.accession))],
              ],
              2
            ),
          ]
        : _vm.reference === "PDB"
        ? [
            _c(
              "v-btn",
              {
                attrs: {
                  href: "https://www.rcsb.org/structure/" + _vm.accession,
                  target: "_blank",
                  rel: "noopener",
                  plain: "",
                  text: "",
                  small: "",
                  icon: "",
                },
              },
              [
                _c("v-icon", { attrs: { small: "" } }, [
                  _vm._v(
                    "\n            " + _vm._s(_vm.$MDI.OpenInNew) + "\n        "
                  ),
                ]),
              ],
              1
            ),
            _vm._v(_vm._s(_vm.accession) + "\n    "),
          ]
        : _c(
            "v-menu",
            {
              attrs: { "close-on-content-click": false },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on }) {
                      return [
                        _c(
                          "span",
                          { staticClass: "d-inline-flex align-center" },
                          [
                            _vm.$slots["accession"]
                              ? _vm._t("accession")
                              : [_vm._v(_vm._s(_vm.accession))],
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              _vm._g(
                                {
                                  attrs: {
                                    plain: "",
                                    text: "",
                                    small: "",
                                    icon: "",
                                  },
                                },
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$MDI.OpenInNew) +
                                      "\n                "
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            },
            [
              _vm._v(" "),
              _vm.reference === "UniProt"
                ? _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        {
                          attrs: {
                            href:
                              "https://www.uniprot.org/uniprotkb/" +
                              _vm.accession,
                            target: "_blank",
                            rel: "noopener",
                          },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [_c("v-list-item-title", [_vm._v("UniProt")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-item",
                        {
                          attrs: {
                            href:
                              "https://uniprot3d.org/atlas/AFDB90v4/#" +
                              _vm.accession,
                            target: "_blank",
                            rel: "noopener",
                          },
                        },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [
                                _vm._v("UniProt3D Atlas"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }